module.exports = __webpack_public_path__ + "static/img/img_t2.febcf0b6.webp";